export const GET_STAFF = "GET_STAFF";

export const GetStaff = () => {
    return { type: GET_STAFF };
};
